/* ========================================================================== *\
IMPORTS
\* ========================================================================== */

import $ from 'jquery';
import LS from 'local-storage';


/* ========================================================================== *\
 LETS
 \* ========================================================================== */

 let contrast = {
    get: get,
    toggleContrast: toggleContrast,
    enable: enable,
    disable: disable
 };

 /* == END LETS ========================================================= */

 /* ========================================================================== *\
  SETUP CONTRAST UTILITY
  \* ========================================================================== */

 // get a11y.contrast value from localstorage
 function get() {
    return LS.get('a11y.contrast');
}

// turn contrast on or off based on localstorage value
function toggleContrast() {
    const savedContrast = LS.get('a11y.contrast');

    // turn on contrast
    if (typeof savedContrast !== 'undefined' && savedContrast === 'true') {
        $('.site').addClass('highcontrast');
    } else { // turn off contrast
        $('.site').removeClass('highcontrast');
    }
}

// set localstorage item
function enable() {
    LS.set('a11y.contrast', 'true');
    toggleContrast();
}

// remove localstorage item
function disable() {
    LS.remove('a11y.contrast');
    toggleContrast();
}

 /* == END SETUP CONTRAST UTILITY ===================================================== */

 /* ========================================================================== *\
  EXPORTS
  \* ========================================================================== */

export default contrast;

 /* == END EXPORTS ====================================================== */
